// @generated drizzle-zero signature:sha256:2b2d8616893cccda72f3e2cd1cc2375f8c7588c07f78abdc8e6a2d8f2511f6f3
// This file was automatically generated by drizzle-zero.
// You should NOT make any changes in this file as it will be overwritten.

import type { Row } from '@rocicorp/zero';
import { createBuilder } from '@rocicorp/zero';

const announcementsTable = {
  name: 'announcements',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    title: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    body: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    pinned: {
      type: 'boolean',
      optional: true,
      customType: null as unknown as boolean
    },
    publishAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'publish_at'
    },
    expiresAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'expires_at'
    },
    authorId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'author_id'
    }
  },
  primaryKey: ['id']
} as const;
const chatChannelMembersTable = {
  name: 'chatChannelMembers',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    organizationId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'organization_id'
    },
    channelId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'channel_id'
    },
    userId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'user_id'
    },
    agentEnabled: {
      type: 'boolean',
      optional: true,
      customType: null as unknown as boolean,
      serverName: 'agent_enabled'
    },
    agentPaused: {
      type: 'boolean',
      optional: true,
      customType: null as unknown as boolean,
      serverName: 'agent_paused'
    },
    responseMode: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'response_mode'
    }
  },
  primaryKey: ['id'],
  serverName: 'chat_channel_members'
} as const;
const chatChannelReadsTable = {
  name: 'chatChannelReads',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    organizationId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'organization_id'
    },
    channelId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'channel_id'
    },
    userId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'user_id'
    },
    lastReadAt: {
      type: 'number',
      optional: false,
      customType: null as unknown as number,
      serverName: 'last_read_at'
    },
    lastReadMessageId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'last_read_message_id'
    }
  },
  primaryKey: ['id'],
  serverName: 'chat_channel_reads'
} as const;
const chatChannelsTable = {
  name: 'chatChannels',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    parentId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'parent_id'
    },
    dmChannel: {
      type: 'boolean',
      optional: true,
      customType: null as unknown as boolean,
      serverName: 'dm_channel'
    },
    name: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    description: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    organizationId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'organization_id'
    },
    dmPairKey: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'dm_pair_key'
    },
    isPrivate: {
      type: 'boolean',
      optional: true,
      customType: null as unknown as boolean,
      serverName: 'is_private'
    },
    topic: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    createdByUserId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'created_by_user_id'
    }
  },
  primaryKey: ['id'],
  serverName: 'chat_channels'
} as const;
const chatMessagesTable = {
  name: 'chatMessages',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    parentId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'parent_id'
    },
    senderId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'sender_id'
    },
    text: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    messageKind: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'message_kind'
    },
    agentRunId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'agent_run_id'
    },
    triggeredByMessageId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'triggered_by_message_id'
    },
    contentPolicyRevision: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'content_policy_revision'
    }
  },
  primaryKey: ['id'],
  serverName: 'chat_messages'
} as const;
const edgesTable = {
  name: 'edges',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    sourceId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'source_id'
    },
    targetId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'target_id'
    }
  },
  primaryKey: ['id']
} as const;
const filesTable = {
  name: 'files',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    organizationId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'organization_id'
    },
    parentId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'parent_id'
    },
    parentType: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'parent_type'
    },
    contentType: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'content_type'
    },
    sizeBytes: {
      type: 'number',
      optional: false,
      customType: null as unknown as number,
      serverName: 'size_bytes'
    },
    filename: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    width: {
      type: 'number',
      optional: true,
      customType: null as unknown as number
    },
    height: {
      type: 'number',
      optional: true,
      customType: null as unknown as number
    },
    uploadedByUserId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'uploaded_by_user_id'
    }
  },
  primaryKey: ['id']
} as const;
const ingredientsTable = {
  name: 'ingredients',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    fullName: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'full_name'
    },
    brandName: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'brand_name'
    },
    description: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    notes: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    role: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    roleFamily: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'role_family'
    },
    recipeId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'recipe_id'
    }
  },
  primaryKey: ['id']
} as const;
const inventoryItemsTable = {
  name: 'inventoryItems',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    name: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    key: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    notes: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    }
  },
  primaryKey: ['id'],
  serverName: 'inventory_items'
} as const;
const knowledgeArticlesTable = {
  name: 'knowledgeArticles',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    organizationId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'organization_id'
    },
    kind: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    title: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    subtitle: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    tags: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    status: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    authorId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'author_id'
    }
  },
  primaryKey: ['id'],
  serverName: 'knowledge_articles'
} as const;
const managerLogbookEntriesTable = {
  name: 'managerLogbookEntries',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    title: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    body: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    authorId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'author_id'
    },
    shiftDate: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'shift_date'
    },
    shiftType: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'shift_type'
    },
    tags: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    }
  },
  primaryKey: ['id'],
  serverName: 'manager_logbook_entries'
} as const;
const menuImportsTable = {
  name: 'menuImports',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    organizationId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'organization_id'
    },
    kind: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    status: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    fileId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'file_id'
    },
    error: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    menuId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'menu_id'
    },
    documentKind: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'document_kind'
    }
  },
  primaryKey: ['id'],
  serverName: 'menu_imports'
} as const;
const menusTable = {
  name: 'menus',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    status: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    startDate: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'start_date'
    },
    endDate: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'end_date'
    },
    serviceStart: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'service_start'
    },
    serviceEnd: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'service_end'
    },
    name: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    subtitle: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    notes: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    kind: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    description: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    origin: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    importId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'import_id'
    }
  },
  primaryKey: ['id']
} as const;
const organizationSearchPreferencesTable = {
  name: 'organizationSearchPreferences',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    organizationId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'organization_id'
    },
    userId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'user_id'
    },
    defaultQuery: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'default_query'
    },
    contentTypeFilters: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'content_type_filters'
    },
    preferenceVersion: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'preference_version'
    }
  },
  primaryKey: ['id'],
  serverName: 'organization_search_preferences'
} as const;
const organizationUsersTable = {
  name: 'organizationUsers',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    role: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    position: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    organizationId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'organization_id'
    },
    userId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'user_id'
    }
  },
  primaryKey: ['id'],
  serverName: 'organization_users'
} as const;
const organizationsTable = {
  name: 'organizations',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    name: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    measurementSystem: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'measurement_system'
    },
    imageGenerationLimit: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'image_generation_limit'
    }
  },
  primaryKey: ['id']
} as const;
const permissionsTable = {
  name: 'permissions',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    permission: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    sourceId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'source_id'
    },
    targetId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'target_id'
    }
  },
  primaryKey: ['id']
} as const;
const propertiesTable = {
  name: 'properties',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    key: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    valueType: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'value_type'
    },
    numberValue: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'number_value'
    },
    stringValue: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'string_value'
    }
  },
  primaryKey: ['id']
} as const;
const recipeIngredientsTable = {
  name: 'recipeIngredients',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    sourceId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'source_id'
    },
    targetId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'target_id'
    },
    quantity: {
      type: 'number',
      optional: true,
      customType: null as unknown as number
    },
    quantityStr: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'quantity_str'
    },
    quantityType: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'quantity_type'
    }
  },
  primaryKey: ['id'],
  serverName: 'recipe_ingredients'
} as const;
const recipesTable = {
  name: 'recipes',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    name: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    subtitle: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    instructions: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    notes: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    status: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    preparation: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    serving: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    service: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    unitSystem: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'unit_system'
    },
    origin: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    importId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'import_id'
    },
    preparationInferred: {
      type: 'boolean',
      optional: true,
      customType: null as unknown as boolean,
      serverName: 'preparation_inferred'
    }
  },
  primaryKey: ['id']
} as const;
const unavailableItemsTable = {
  name: 'unavailableItems',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    },
    name: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    department: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    reason: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    expectedBack: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'expected_back'
    },
    resolvedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'resolved_at'
    },
    linkedInventoryItemId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'linked_inventory_item_id'
    },
    linkedWareId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'linked_ware_id'
    },
    linkedIngredientId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'linked_ingredient_id'
    },
    createdByUserId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'created_by_user_id'
    },
    updatedByUserId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'updated_by_user_id'
    },
    resolvedByUserId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'resolved_by_user_id'
    },
    deletedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'deleted_at'
    },
    deletedByUserId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'deleted_by_user_id'
    },
    canonicalName: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'canonical_name'
    }
  },
  primaryKey: ['id'],
  serverName: 'unavailable_items'
} as const;
const userContactsTable = {
  name: 'userContacts',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    userId: {
      type: 'string',
      optional: false,
      customType: null as unknown as string,
      serverName: 'user_id'
    },
    email: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    phone: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    socialLinks: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'social_links'
    },
    createdAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'created_at'
    },
    updatedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'updated_at'
    },
    globalSequence: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'global_sequence'
    }
  },
  primaryKey: ['id'],
  serverName: 'user_contacts'
} as const;
const usersTable = {
  name: 'users',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    clerkId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'clerk_id'
    },
    defaultOrganizationId: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'default_organization_id'
    },
    firstName: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'first_name'
    },
    lastName: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'last_name'
    },
    imageUrl: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'image_url'
    },
    about: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    },
    shareContactWithOrg: {
      type: 'boolean',
      optional: false,
      customType: null as unknown as boolean,
      serverName: 'share_contact_with_org'
    },
    welcomeCompletedAt: {
      type: 'number',
      optional: true,
      customType: null as unknown as number,
      serverName: 'welcome_completed_at'
    },
    measurementSystem: {
      type: 'string',
      optional: true,
      customType: null as unknown as string,
      serverName: 'measurement_system'
    }
  },
  primaryKey: ['id']
} as const;
const waresTable = {
  name: 'wares',
  columns: {
    id: {
      type: 'string',
      optional: false,
      customType: null as unknown as string
    },
    label: {
      type: 'string',
      optional: true,
      customType: null as unknown as string
    }
  },
  primaryKey: ['id']
} as const;
/**
 * The Zero schema object.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const schema = {
  tables: {
    announcements: announcementsTable,
    chatChannelMembers: chatChannelMembersTable,
    chatChannelReads: chatChannelReadsTable,
    chatChannels: chatChannelsTable,
    chatMessages: chatMessagesTable,
    edges: edgesTable,
    files: filesTable,
    ingredients: ingredientsTable,
    inventoryItems: inventoryItemsTable,
    knowledgeArticles: knowledgeArticlesTable,
    managerLogbookEntries: managerLogbookEntriesTable,
    menuImports: menuImportsTable,
    menus: menusTable,
    organizationSearchPreferences: organizationSearchPreferencesTable,
    organizationUsers: organizationUsersTable,
    organizations: organizationsTable,
    permissions: permissionsTable,
    properties: propertiesTable,
    recipeIngredients: recipeIngredientsTable,
    recipes: recipesTable,
    unavailableItems: unavailableItemsTable,
    userContacts: userContactsTable,
    users: usersTable,
    wares: waresTable
  },
  relationships: {},
  enableLegacyQueries: true,
  enableLegacyMutators: false
} as const;

/**
 * Represents the Zero schema type.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Schema = typeof schema;
/**
 * Represents a row from the "announcements" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Announcement = Row<(typeof schema)['tables']['announcements']>;
/**
 * Represents a row from the "chatChannelMembers" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ChatChannelMember = Row<
  (typeof schema)['tables']['chatChannelMembers']
>;
/**
 * Represents a row from the "chatChannelReads" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ChatChannelRead = Row<
  (typeof schema)['tables']['chatChannelReads']
>;
/**
 * Represents a row from the "chatChannels" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ChatChannel = Row<(typeof schema)['tables']['chatChannels']>;
/**
 * Represents a row from the "chatMessages" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ChatMessage = Row<(typeof schema)['tables']['chatMessages']>;
/**
 * Represents a row from the "edges" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Edge = Row<(typeof schema)['tables']['edges']>;
/**
 * Represents a row from the "files" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type File = Row<(typeof schema)['tables']['files']>;
/**
 * Represents a row from the "ingredients" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Ingredient = Row<(typeof schema)['tables']['ingredients']>;
/**
 * Represents a row from the "inventoryItems" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type InventoryItem = Row<(typeof schema)['tables']['inventoryItems']>;
/**
 * Represents a row from the "knowledgeArticles" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type KnowledgeArticle = Row<
  (typeof schema)['tables']['knowledgeArticles']
>;
/**
 * Represents a row from the "managerLogbookEntries" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ManagerLogbookEntry = Row<
  (typeof schema)['tables']['managerLogbookEntries']
>;
/**
 * Represents a row from the "menuImports" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type MenuImport = Row<(typeof schema)['tables']['menuImports']>;
/**
 * Represents a row from the "menus" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Menu = Row<(typeof schema)['tables']['menus']>;
/**
 * Represents a row from the "organizationSearchPreferences" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type OrganizationSearchPreference = Row<
  (typeof schema)['tables']['organizationSearchPreferences']
>;
/**
 * Represents a row from the "organizationUsers" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type OrganizationUser = Row<
  (typeof schema)['tables']['organizationUsers']
>;
/**
 * Represents a row from the "organizations" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Organization = Row<(typeof schema)['tables']['organizations']>;
/**
 * Represents a row from the "permissions" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Permission = Row<(typeof schema)['tables']['permissions']>;
/**
 * Represents a row from the "properties" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Property = Row<(typeof schema)['tables']['properties']>;
/**
 * Represents a row from the "recipeIngredients" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RecipeIngredient = Row<
  (typeof schema)['tables']['recipeIngredients']
>;
/**
 * Represents a row from the "recipes" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Recipe = Row<(typeof schema)['tables']['recipes']>;
/**
 * Represents a row from the "unavailableItems" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type UnavailableItem = Row<
  (typeof schema)['tables']['unavailableItems']
>;
/**
 * Represents a row from the "users" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type User = Row<(typeof schema)['tables']['users']>;
/**
 * Represents a row from the "wares" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Ware = Row<(typeof schema)['tables']['wares']>;

/**
 * Represents the ZQL query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const zql = createBuilder(schema);
/**
 * Represents the Zero schema query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const builder = zql;
